
import React from 'react';
import 'stylesheets/fonts.scss';
import 'stylesheets/colors.scss';
import 'stylesheets/layout.scss';
import 'stylesheets/ConfirmModal.scss';
import text from 'strings/text';
import { injectIntl } from 'react-intl';

export function RemoveItemModal({ removeItem, closeModal, title, explain }) {

    const handleCancel = (event) => {
        closeModal();
    }
    const handleConfirm = (event) => {
        removeItem();
        closeModal();
    }

    return (
        <div className="confirm-modal-container">
            <label className="title-text">{title}</label>
            <div className='body-text1 fs14'>{explain}</div>

            <div className="confirm-button-wrap">
                <button className="confirm-button-cancel" onClick={handleCancel}>{text.cancel}</button>
                <button className="confirm-button button-enabled" onClick={handleConfirm}>{text.remove}</button>
            </div>
        </div>
    )
}

export default injectIntl(RemoveItemModal);